import { __decorate } from "tslib";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { soapAttribute, SoapRequestData, SoapService, soapNodeText } from "../SoapService";
export class AddressData extends SoapRequestData {
    constructor() {
        super();
        this.addressType = "SoldTo";
    }
    /** Serialize to xml string. */
    static Serialize(pAddress) {
        return (SoapService.SerializeDataToXml({ AddressData: pAddress }, () => { }));
    }
    /** Deserialize xml string. */
    static Deserialize(pData, pResetContactIds = true) {
        const tObj = SoapService.DeserializeXmlToObject(pData);
        if (tObj == null || tObj.AddressData == null) {
            return (null);
        }
        const tAddress = AddressData.FromSoap(tObj.AddressData);
        //reset contact ids they are only valid in the current session
        if (tAddress != null) {
            if (pResetContactIds && tAddress.contacts != null) {
                for (const tContact of tAddress.contacts) {
                    tContact.id = 0;
                }
            }
            return (tAddress);
        }
        return (null);
    }
    /** @internal */
    _getPropertyValue(pProperty) {
        //handle extra commAddresses array wrapper
        if (pProperty === "commAddresses")
            return (this.commAddresses != null ? { commAddress: this.commAddresses } : undefined);
        //handle extra contacts array wrapper
        if (pProperty === "contacts")
            return (this.contacts != null ? { contact: this.contacts } : undefined);
        return (super._getPropertyValue(pProperty));
    }
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, AddressData.FromSoapNU));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, AddressData.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tData = new AddressData();
        tData.addressNumber = pSoapData.addressNumber;
        tData.addressId = pSoapData.addressId;
        tData.title = pSoapData.title;
        tData.name1 = pSoapData.name1;
        tData.name2 = pSoapData.name2;
        tData.name3 = pSoapData.name3;
        tData.name4 = pSoapData.name4;
        tData.street = pSoapData.street;
        tData.street2 = pSoapData.street2;
        tData.countryCode = pSoapData.countryCode;
        tData.postalCode = pSoapData.postalCode;
        tData.location = pSoapData.location;
        tData.district = pSoapData.district;
        tData.regionCode = pSoapData.regionCode;
        tData.poBox = pSoapData.poBox;
        tData.taxCode = pSoapData.taxCode;
        tData.taxCodeEU = pSoapData.taxCodeEU;
        tData.taxCodeUSA = pSoapData.taxCodeUSA;
        tData.addressType = pSoapData.addressType;
        //handle extra commAddresses array wrapper
        if (pSoapData.commAddresses != null && pSoapData.commAddresses.commAddress != null)
            tData.commAddresses = CommAddress.FromSoapArrayNU(pSoapData.commAddresses.commAddress);
        //handle extra contacts array wrapper
        if (pSoapData.contacts != null && pSoapData.contacts.contact != null)
            tData.contacts = ContactData.FromSoapArrayNU(pSoapData.contacts.contact);
        return (tData);
    }
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (AddressData.FromSoapNU(pSoapData));
    }
}
__decorate([
    soapAttribute()
], AddressData.prototype, "addressType", void 0);
export class AutoSaveOptions extends SoapRequestData {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tOptions = new AutoSaveOptions();
        tOptions.onSessionClose = SoapService.SoapDataToBool(pSoapData.onSessionClose);
        tOptions.onProjectClose = SoapService.SoapDataToBool(pSoapData.onProjectClose);
        tOptions.periodical = SoapService.SoapDataToBool(pSoapData.periodical);
        tOptions.interval = pSoapData.interval;
        tOptions.idleTime = pSoapData.idleTime;
        return (tOptions);
    }
}
__decorate([
    soapAttribute()
], AutoSaveOptions.prototype, "onSessionClose", void 0);
__decorate([
    soapAttribute()
], AutoSaveOptions.prototype, "onProjectClose", void 0);
__decorate([
    soapAttribute()
], AutoSaveOptions.prototype, "periodical", void 0);
__decorate([
    soapAttribute()
], AutoSaveOptions.prototype, "interval", void 0);
__decorate([
    soapAttribute()
], AutoSaveOptions.prototype, "idleTime", void 0);
export class CommAddress extends SoapRequestData {
    constructor() {
        super();
        this.value = "";
        this.type = "Phone";
        this.scope = "Business";
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, CommAddress.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tAddress = new CommAddress();
        tAddress.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tAddress.type = pSoapData.type;
        tAddress.scope = pSoapData.scope;
        return (tAddress);
    }
}
__decorate([
    soapNodeText()
], CommAddress.prototype, "value", void 0);
__decorate([
    soapAttribute()
], CommAddress.prototype, "type", void 0);
__decorate([
    soapAttribute()
], CommAddress.prototype, "scope", void 0);
export class ContactData extends SoapRequestData {
    constructor() {
        super();
        this.id = 0;
    }
    /** @internal */
    _getPropertyValue(pProperty) {
        //handle extra commAddresses array wrapper
        if (pProperty === "commAddresses")
            return (this.commAddresses != null ? { commAddress: this.commAddresses } : undefined);
        return (super._getPropertyValue(pProperty));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ContactData.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tData = new ContactData();
        tData.contactNumber = pSoapData.contactNumber;
        tData.title = pSoapData.title;
        tData.firstName = pSoapData.firstName;
        tData.lastName = pSoapData.lastName;
        tData.id = pSoapData.id;
        tData.contactType = pSoapData.contactType;
        //handle extra commAddresses array wrapper
        if (pSoapData.commAddresses != null && pSoapData.commAddresses.commAddress != null)
            tData.commAddresses = CommAddress.FromSoapArrayNU(pSoapData.commAddresses.commAddress);
        return (tData);
    }
}
__decorate([
    soapAttribute()
], ContactData.prototype, "id", void 0);
__decorate([
    soapAttribute()
], ContactData.prototype, "contactType", void 0);
export class DeleteProjectsOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], DeleteProjectsOptions.prototype, "ignoreVersionNumbers", void 0);
__decorate([
    soapAttribute()
], DeleteProjectsOptions.prototype, "failIfNonExistent", void 0);
__decorate([
    soapAttribute()
], DeleteProjectsOptions.prototype, "failIfPermissionDenied", void 0);
__decorate([
    soapAttribute()
], DeleteProjectsOptions.prototype, "failIfNotLockable", void 0);
__decorate([
    soapAttribute()
], DeleteProjectsOptions.prototype, "ignoreLocks", void 0);
export class DisplayName extends SoapRequestData {
    constructor() {
        super();
        this.value = "";
        this.language = "";
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, DisplayName.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tName = new DisplayName();
        tName.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tName.language = pSoapData.language;
        return (tName);
    }
}
__decorate([
    soapNodeText()
], DisplayName.prototype, "value", void 0);
__decorate([
    soapAttribute()
], DisplayName.prototype, "language", void 0);
export class FormattedText extends SoapRequestData {
    constructor() {
        super();
        this.value = "";
        this.language = "";
        this.format = "None";
    }
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, FormattedText.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tText = new FormattedText();
        tText.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tText.language = pSoapData.language;
        tText.format = pSoapData.format;
        return (tText);
    }
}
__decorate([
    soapNodeText()
], FormattedText.prototype, "value", void 0);
__decorate([
    soapAttribute()
], FormattedText.prototype, "language", void 0);
__decorate([
    soapAttribute()
], FormattedText.prototype, "format", void 0);
export class ListCompletionsOptions extends SoapRequestData {
    constructor() {
        super();
        this.prefix = "";
    }
}
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "projectGroupPattern", void 0);
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "addressType", void 0);
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "contactType", void 0);
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "limit", void 0);
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "filterAttribute", void 0);
__decorate([
    soapAttribute()
], ListCompletionsOptions.prototype, "ignoreCase", void 0);
export class ListProjectsOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], ListProjectsOptions.prototype, "projectGroupPattern", void 0);
__decorate([
    soapAttribute()
], ListProjectsOptions.prototype, "addressType", void 0);
__decorate([
    soapAttribute()
], ListProjectsOptions.prototype, "contactType", void 0);
__decorate([
    soapAttribute()
], ListProjectsOptions.prototype, "offset", void 0);
__decorate([
    soapAttribute()
], ListProjectsOptions.prototype, "limit", void 0);
export class Permission extends SoapRequestData {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, Permission.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tPermission = new Permission();
        tPermission.userRole = pSoapData.userRole;
        tPermission.create = SoapService.SoapDataToBool(pSoapData.create);
        tPermission.read = SoapService.SoapDataToBool(pSoapData.read);
        tPermission.write = SoapService.SoapDataToBool(pSoapData.write);
        tPermission.delete = SoapService.SoapDataToBool(pSoapData.delete);
        tPermission.list = SoapService.SoapDataToBool(pSoapData.list);
        return (tPermission);
    }
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (Permission.FromSoapNU(pSoapData));
    }
}
__decorate([
    soapAttribute()
], Permission.prototype, "userRole", void 0);
__decorate([
    soapAttribute()
], Permission.prototype, "create", void 0);
__decorate([
    soapAttribute()
], Permission.prototype, "read", void 0);
__decorate([
    soapAttribute()
], Permission.prototype, "write", void 0);
__decorate([
    soapAttribute()
], Permission.prototype, "delete", void 0);
__decorate([
    soapAttribute()
], Permission.prototype, "list", void 0);
export class PriceList extends SoapRequestData {
    constructor() {
        super();
        this.id = "";
    }
    /** @internal */
    _getPropertyValue(pProperty) {
        //handle extra userRoles array wrapper
        if (pProperty === "userRoles")
            return (this.userRoles != null ? { userRole: this.userRoles } : undefined);
        //handle extra displayNames array wrapper
        if (pProperty === "displayNames")
            return (this.displayNames != null ? { displayName: this.displayNames } : undefined);
        return (super._getPropertyValue(pProperty));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, PriceList.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tList = new PriceList();
        tList.id = pSoapData.id;
        tList.startup = pSoapData.startup;
        tList.availableToCurrentUser = SoapService.SoapDataToBool(pSoapData.availableToCurrentUser);
        //handle extra userRoles array wrapper
        if (pSoapData.userRoles != null && pSoapData.userRoles.userRole != null)
            tList.userRoles = SoapService.SoapDataToArrayNU(pSoapData.userRoles.userRole);
        //handle extra displayNames array wrapper
        if (pSoapData.displayNames != null && pSoapData.displayNames.displayName != null)
            tList.displayNames = DisplayName.FromSoapArrayNU(pSoapData.displayNames.displayName);
        return (tList);
    }
}
__decorate([
    soapAttribute()
], PriceList.prototype, "id", void 0);
__decorate([
    soapAttribute()
], PriceList.prototype, "startup", void 0);
__decorate([
    soapAttribute()
], PriceList.prototype, "availableToCurrentUser", void 0);
export class ProjectData extends SoapRequestData {
    /** @internal */
    _getPropertyValue(pProperty) {
        //handle extra addresses array wrapper
        if (pProperty === "addresses")
            return (this.addresses != null ? { address: this.addresses } : undefined);
        //handle extra keywords array wrapper
        if (pProperty === "keywords")
            return (this.keywords != null ? { keyword: this.keywords } : undefined);
        //handle extra languages array wrapper
        if (pProperty === "languages")
            return (this.languages != null ? { language: this.languages } : undefined);
        //handle extra projectTexts array wrapper
        if (pProperty === "projectTexts")
            return (this.projectTexts != null ? { projectText: this.projectTexts } : undefined);
        return (super._getPropertyValue(pProperty));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ProjectData.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tData = new ProjectData();
        tData.uri = pSoapData.uri;
        tData.projectName = pSoapData.projectName;
        tData.projectNumber = pSoapData.projectNumber;
        tData.description = pSoapData.description;
        tData.externalReferenceNumber = pSoapData.externalReferenceNumber;
        tData.externalReferenceText = pSoapData.externalReferenceText;
        tData.customerNumber = pSoapData.customerNumber;
        tData.externalCustomerId = pSoapData.externalCustomerId;
        tData.customerRelatedRemarks = pSoapData.customerRelatedRemarks;
        tData.company = pSoapData.company;
        tData.generalAgreementNumber = pSoapData.generalAgreementNumber;
        tData.projectGroup = pSoapData.projectGroup;
        tData.projectId = pSoapData.projectId;
        tData.projectVersion = SoapService.SoapDataToInt(pSoapData.projectVersion);
        tData.priceList = pSoapData.priceList;
        tData.projectState = pSoapData.projectState;
        tData.created = pSoapData.created;
        tData.lastModified = pSoapData.lastModified;
        tData.projectDate = pSoapData.projectDate;
        tData.validToDate = pSoapData.validToDate;
        tData.createdByUser = pSoapData.createdByUser;
        tData.modifiedByUser = pSoapData.modifiedByUser;
        tData.changed = SoapService.SoapDataToBool(pSoapData.changed);
        tData.locked = SoapService.SoapDataToBool(pSoapData.locked);
        tData.lockHolder = pSoapData.lockHolder;
        tData.lockTime = pSoapData.lockTime;
        tData.projectNumberEditable = SoapService.SoapDataToBool(pSoapData.projectNumberEditable);
        //handle extra addresses array wrapper
        if (pSoapData.addresses != null && pSoapData.addresses.address != null)
            tData.addresses = AddressData.FromSoapArrayNU(pSoapData.addresses.address);
        //handle extra keywords array wrapper
        if (pSoapData.keywords != null && pSoapData.keywords.keyword != null)
            tData.keywords = SoapService.SoapDataToArrayNU(pSoapData.keywords.keyword);
        //handle extra languages array wrapper
        if (pSoapData.languages != null && pSoapData.languages.language != null)
            tData.languages = SoapService.SoapDataToArrayNU(pSoapData.languages.language);
        //handle extra projectTexts array wrapper
        if (pSoapData.projectTexts != null && pSoapData.projectTexts.projectText != null)
            tData.projectTexts = ProjectText.FromSoapArrayNU(pSoapData.projectTexts.projectText);
        return (tData);
    }
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (ProjectData.FromSoapNU(pSoapData));
    }
}
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectGroup", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectId", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectVersion", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "priceList", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectState", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "created", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "lastModified", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectDate", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "validToDate", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "createdByUser", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "modifiedByUser", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "changed", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "locked", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "lockHolder", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "lockTime", void 0);
__decorate([
    soapAttribute()
], ProjectData.prototype, "projectNumberEditable", void 0);
export class ProjectFilterNode extends SoapRequestData {
}
export class ProjectFilter extends ProjectFilterNode {
    constructor() {
        super();
        this.arguments = new Array();
        this.operator = "And";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilter");
    }
}
__decorate([
    soapAttribute()
], ProjectFilter.prototype, "operator", void 0);
__decorate([
    soapAttribute()
], ProjectFilter.prototype, "ignoreCase", void 0);
export class ProjectFilterAttribute extends ProjectFilterNode {
    constructor() {
        super();
        this.attribute = "ProjectName";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilterAttribute");
    }
}
__decorate([
    soapAttribute()
], ProjectFilterAttribute.prototype, "attribute", void 0);
export class ProjectFilterValue extends ProjectFilterNode {
}
export class ProjectFilterStringValue extends ProjectFilterValue {
    constructor() {
        super();
        this.value = "";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilterStringValue");
    }
}
export class ProjectFilterDateTimeValue extends ProjectFilterValue {
    constructor() {
        super();
        this.value = "";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilterDateTimeValue");
    }
}
__decorate([
    soapAttribute()
], ProjectFilterDateTimeValue.prototype, "value", void 0);
export class ProjectFilterDateValue extends ProjectFilterValue {
    constructor() {
        super();
        this.date = "";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilterDateValue");
    }
}
__decorate([
    soapAttribute()
], ProjectFilterDateValue.prototype, "date", void 0);
export class ProjectFilterStateValue extends ProjectFilterValue {
    constructor() {
        super();
        this.value = "Undefined";
    }
    /** @internal */
    _getClassName() {
        return ("ProjectFilterStateValue");
    }
}
__decorate([
    soapAttribute()
], ProjectFilterStateValue.prototype, "value", void 0);
export class ProjectGroup extends SoapRequestData {
    constructor() {
        super();
        this.id = "";
    }
    /** @internal */
    _getPropertyValue(pProperty) {
        //handle extra priceLists array wrapper
        if (pProperty === "priceLists")
            return (this.priceLists != null ? { priceList: this.priceLists } : undefined);
        //handle extra permissions array wrapper
        if (pProperty === "permissions")
            return (this.permissions != null ? { permission: this.permissions } : undefined);
        //handle extra simpleNames array wrapper
        if (pProperty === "simpleNames")
            return (this.simpleNames != null ? { displayName: this.simpleNames } : undefined);
        //handle extra fullNames array wrapper
        if (pProperty === "fullNames")
            return (this.fullNames != null ? { displayName: this.fullNames } : undefined);
        //handle extra subgroupTitles array wrapper
        if (pProperty === "subgroupTitles")
            return (this.subgroupTitles != null ? { displayName: this.subgroupTitles } : undefined);
        return (super._getPropertyValue(pProperty));
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ProjectGroup.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tGroup = new ProjectGroup();
        tGroup.numberScheme = ProjectNumberScheme.FromSoap(pSoapData.numberScheme);
        tGroup.id = pSoapData.id;
        tGroup.folder = SoapService.SoapDataToBool(pSoapData.folder);
        //handle extra priceLists array wrapper
        if (pSoapData.priceLists != null && pSoapData.priceLists.priceList != null)
            tGroup.priceLists = PriceList.FromSoapArrayNU(pSoapData.priceLists.priceList);
        //handle extra permissions array wrapper
        if (pSoapData.permissions != null && pSoapData.permissions.permission != null)
            tGroup.permissions = Permission.FromSoapArrayNU(pSoapData.permissions.permission);
        //handle extra simpleNames array wrapper
        if (pSoapData.simpleNames != null && pSoapData.simpleNames.displayName != null)
            tGroup.simpleNames = DisplayName.FromSoapArrayNU(pSoapData.simpleNames.displayName);
        //handle extra fullNames array wrapper
        if (pSoapData.fullNames != null && pSoapData.fullNames.displayName != null)
            tGroup.fullNames = DisplayName.FromSoapArrayNU(pSoapData.fullNames.displayName);
        //handle extra subgroupTitles array wrapper
        if (pSoapData.subgroupTitles != null && pSoapData.subgroupTitles.displayName != null)
            tGroup.subgroupTitles = DisplayName.FromSoapArrayNU(pSoapData.subgroupTitles.displayName);
        tGroup.currentUserPermissions = Permission.FromSoap(pSoapData.currentUserPermissions);
        return (tGroup);
    }
}
__decorate([
    soapAttribute()
], ProjectGroup.prototype, "id", void 0);
__decorate([
    soapAttribute()
], ProjectGroup.prototype, "folder", void 0);
export class ProjectNumberScheme extends SoapRequestData {
    constructor() {
        super();
        this.id = "";
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ProjectNumberScheme.FromSoapNU));
    }
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tScheme = new ProjectNumberScheme();
        tScheme.id = pSoapData.id;
        tScheme.pattern = pSoapData.pattern;
        tScheme.minimumValue = SoapService.SoapDataToInt(pSoapData.minimumValue);
        tScheme.maximumValue = SoapService.SoapDataToInt(pSoapData.maximumValue);
        tScheme.nextValue = SoapService.SoapDataToInt(pSoapData.nextValue);
        tScheme.currentYear = SoapService.SoapDataToInt(pSoapData.currentYear);
        tScheme.zoneId = pSoapData.zoneId;
        return (tScheme);
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (ProjectNumberScheme.FromSoap(pSoapData));
    }
}
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "id", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "pattern", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "minimumValue", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "maximumValue", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "nextValue", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "currentYear", void 0);
__decorate([
    soapAttribute()
], ProjectNumberScheme.prototype, "zoneId", void 0);
export class ProjectSortSpec extends SoapRequestData {
    constructor() {
        super();
        this.attribute = "CreateTime";
    }
}
__decorate([
    soapAttribute()
], ProjectSortSpec.prototype, "attribute", void 0);
__decorate([
    soapAttribute()
], ProjectSortSpec.prototype, "ascending", void 0);
__decorate([
    soapAttribute()
], ProjectSortSpec.prototype, "undefFirst", void 0);
__decorate([
    soapAttribute()
], ProjectSortSpec.prototype, "ignoreCase", void 0);
export class ProjectText extends SoapRequestData {
    constructor() {
        super();
        this.type = "HeaderText";
    }
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ProjectText.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tText = new ProjectText();
        tText.texts = FormattedText.FromSoapArray(pSoapData.texts);
        tText.type = pSoapData.type;
        return (tText);
    }
}
__decorate([
    soapAttribute()
], ProjectText.prototype, "type", void 0);
export class SaveProjectOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], SaveProjectOptions.prototype, "projectGroup", void 0);
__decorate([
    soapAttribute()
], SaveProjectOptions.prototype, "priceList", void 0);
__decorate([
    soapAttribute()
], SaveProjectOptions.prototype, "noVersionCheck", void 0);
__decorate([
    soapAttribute()
], SaveProjectOptions.prototype, "autoDelete", void 0);
////////
// response types
export class CountryData {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, CountryData.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tData = new CountryData();
        tData.displayName = pSoapData.displayName;
        tData.iso3166Code = pSoapData.iso3166Code;
        return (tData);
    }
}
export class SubdivisionData {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, SubdivisionData.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tData = new SubdivisionData();
        tData.iso3166names = SoapService.SoapDataToArrayNU(pSoapData.iso3166names);
        tData.localVariants = SoapService.SoapDataToArray(pSoapData.localVariants);
        tData.languageCodes = SoapService.SoapDataToArrayNU(pSoapData.languageCodes);
        tData.displayName = pSoapData.displayName;
        tData.category = pSoapData.category;
        tData.iso3166Code = pSoapData.iso3166Code;
        tData.regionCode = pSoapData.regionCode;
        tData.parentSubdivision = pSoapData.parentSubdivision;
        return (tData);
    }
}
